import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { Marquee } from "../components/Marquee";
import { SERVICES } from "../lib/content";

export default function Servicii() {
  return (
    <main data-testid="servicii-page">
      <section className="grain-overlay wood-ring bg-anthracite pb-20 pt-36 text-cream lg:pb-28 lg:pt-44">
        <div className="relative z-[2] mx-auto max-w-7xl px-5 sm:px-8">
          <Reveal>
            <p className="font-mono text-xs uppercase tracking-[0.35em] text-oak">Servicii & ce realizăm</p>
            <h1 className="mt-5 max-w-3xl font-serif text-4xl font-black leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl">
              Tot ce ține de lemn, <em className="italic text-oak">făcut ca la carte</em>
            </h1>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-cream/70 sm:text-lg">
              Executăm la comandă mobilier personalizat și orice ține de tâmplărie din
              lemn masiv, MDF și PAL, pe dimensiunile exacte ale spațiului tău.
            </p>
          </Reveal>
        </div>
      </section>

      <Marquee />

      <section className="mx-auto max-w-7xl px-5 py-20 sm:px-8 lg:py-28">
        <div className="space-y-20 lg:space-y-28">
          {SERVICES.map((s, i) => (
            <Reveal key={s.id}>
              <article
                data-testid={`service-detail-${s.id}`}
                className={`grid items-center gap-10 lg:grid-cols-12 lg:gap-14 ${
                  i % 2 === 1 ? "" : ""
                }`}
              >
                <div className={`relative lg:col-span-5 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
                  <span className="absolute -left-3 -top-3 h-full w-full border border-oak/50" aria-hidden="true" />
                  <div className="relative aspect-[4/3] overflow-hidden">
                    <img
                      src={s.image}
                      alt={s.title}
                      data-testid={`service-image-${s.id}`}
                      loading="lazy"
                      className="h-full w-full object-cover transition-transform duration-700 hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_35%,transparent_45%,rgba(24,21,18,0.4)_100%)]" />
                  </div>
                </div>
                <div className={`lg:col-span-7 ${i % 2 === 1 ? "lg:order-1" : ""}`}>
                  <span className="font-serif text-5xl font-black text-oak/35">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <h2 className="mt-4 font-serif text-2xl font-bold tracking-tight text-ink sm:text-3xl lg:text-4xl">
                    {s.title}
                  </h2>
                  <p className="mt-4 max-w-xl text-sm leading-relaxed text-clay sm:text-base">
                    {s.description}
                  </p>
                  <p className="mt-5 font-mono text-[11px] uppercase tracking-[0.2em] text-walnut">
                    {s.materials}
                  </p>
                  <Link
                    to="/contact"
                    data-testid={`service-cta-${s.id}`}
                    className="group mt-8 inline-flex h-12 items-center gap-3 rounded-full bg-anthracite px-7 text-xs font-bold uppercase tracking-[0.15em] text-cream transition-all duration-300 hover:-translate-y-0.5 hover:bg-walnut"
                  >
                    Cere ofertă pentru acest proiect
                    <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1.5" />
                  </Link>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
}
